export const questionHelp = [
    {
        question : 'How can I pay for my order?'
    },
    {
        question : 'Can I pay by bank transfer?'
    },
    {
        question : 'What is Amazon Pay?'
    },
    {
        question : 'I want to change my account information'
    },
    {
        question : 'How can I pay for my order?'
    }
]